import React from 'react';
import uuid from 'react-uuid';
import GridSkeletonCells from './Cells';
import { GridSkeletonProps } from './GridSkeleton.props';
import { classes, Root } from './GridSkeleton.styles';


const GridSkeleton = ({ rows = new Array(10).fill({}), maxRows = 10, maxColumns = 10 }: GridSkeletonProps) => (
  <Root>
    {rows.slice(0, maxRows).map((_, rowIndex) => (
      <div key={uuid()} className={classes.row}>
        <GridSkeletonCells row={rowIndex} maxColumns={maxColumns} classes={classes} />
      </div>
    ))}
  </Root>
);

export default GridSkeleton;
